import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter} from "react-router-dom";
import './index.css';
import App from './App';
import { LanguageProvider } from './configs/LanguageContext';

const basename = process.env.REACT_APP_BASENAME || '/';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename={basename}>
        <LanguageProvider>
          <App />
        </LanguageProvider>
    </BrowserRouter>
);

